import { render, staticRenderFns } from "./TrophyIcon.vue?vue&type=template&id=5e359df9&scoped=true&"
import script from "./TrophyIcon.vue?vue&type=script&lang=js&"
export * from "./TrophyIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrophyIcon.vue?vue&type=style&index=0&id=5e359df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e359df9",
  null
  
)

export default component.exports